import { render, staticRenderFns } from "./PrivateMessage.vue?vue&type=template&id=0ec76905&scoped=true&"
import script from "./PrivateMessage.vue?vue&type=script&lang=js&"
export * from "./PrivateMessage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateMessage.vue?vue&type=style&index=0&id=0ec76905&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec76905",
  null
  
)

export default component.exports